import { render, staticRenderFns } from "./FarmCardList.vue?vue&type=template&id=845af73e&scoped=true&"
import script from "./FarmCardList.vue?vue&type=script&lang=js&"
export * from "./FarmCardList.vue?vue&type=script&lang=js&"
import style0 from "./FarmCardList.vue?vue&type=style&index=0&id=845af73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845af73e",
  null
  
)

export default component.exports